import React from "react";
import { ReactComponent as LoadingSvg } from "../../assets/icons/NarratorTab/Dual Ring-1s-32px.svg";

const QuizSavingModal = () => {
  return (
    <div className="quiz-editor-saving-modal">
      <LoadingSvg className="quiz-editor-spinner" />
    </div>
  );
};

export default QuizSavingModal;
